import React from 'react';
import { useData } from 'modules/corporatehub/context/dataContext';
import * as Styled from './StyledCorporateHubStartup';
import LeftSession from './components/LeftSession';
import RightSession from './components/RightSession';

export default function CorporateHubStartupView(props) {
    const dataContext = useData();
    const { startupsPageVars } = dataContext.state;
    return (
        <Styled.SessionContainer>
            <LeftSession data={startupsPageVars} />
            <RightSession data={startupsPageVars} />
        </Styled.SessionContainer>
    );
}
